<div class="Customers overview-loyalty ui-g">

  <div class="ui-g-12 ui-lg-6">
    <h1 class="step-title">{{ 'loyalty_chart.overview_loyalty' | translate }}</h1>
  </div>
  <div class="ui-g-12 ui-lg-12">
    <p-steps [model]="items" [(activeIndex)]="activeIndex"  [readonly]="false"></p-steps>

    <div class="ui-g-12">

      <kv-search-toolbar
        [dateBoxEnabled]="true"
        [date_structure]="searchModel.date_structure"
        [card_modes]="searchModel.card_modes"
        [clusters]="searchModel.cluster_list"
        [customersBoxEnabled]="false"
        [clusterFieldEnabled]="false"
        [selectedElapsedStart]="searchModel.selectedStartDate"
        [selectedElapsedEnd]="searchModel.selectedEndDate"
        [group_types]="searchModel.group_types"
        [groups]="searchModel.groups"
        [areas]="searchModel.areas"
        [stores]="searchModel.stores"
        (onDateStructureSelectionChange)="dateStructureSelectionChange($event)"
        [disableMutualExclusivity]="false"
        appQFilter
        (onQFilter)="performFilter($event)"
      ></kv-search-toolbar>
    </div>

    <div class="overview-container card ui-g-nopad">
      <app-overview-loyalty-value [hidden]="activeIndex !== 0">
      </app-overview-loyalty-value>

      <app-overview-loyalty-points [hidden]="activeIndex !== 1" #loyaltyPoints>
      </app-overview-loyalty-points>
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/overview/overview-loyalty/loyalty-overview.component.html